import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import qs from 'query-string';

import ThankYou from './ThankYou';
import { getPurchaseMetadataFromParams } from './helpers';

const propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

const ThankYouView = ({ location }) => {
  const queryParams = qs.parse(location.search);
  const { purchaseType, purchaseMetadata } = getPurchaseMetadataFromParams(
    queryParams,
  );

  if (!purchaseType) {
    return null;
  }

  return (
    <Fragment>
      <Helmet>
        <title>Thank You &ndash; Waldo Photos</title>
      </Helmet>

      <div className="thank-you-view">
        <div className="thank-you-view-wrapper">
          <ThankYou
            purchaseType={purchaseType}
            purchaseMetadata={purchaseMetadata}
            onRequestClose={() => window.close()}
          />
        </div>
      </div>
    </Fragment>
  );
};

ThankYouView.propTypes = propTypes;

export default withRouter(ThankYouView);
